import { axiosSwagger } from "@/axios";

export const state = {
}


export const getters = {
}


export const mutations = {
}


export const actions = {
    // SHARE FILE LINK
    // eslint-disable-next-line no-unused-vars
    async getLinkByFileId({ commit }, id) {
        return await axiosSwagger
            .get(`/api/FileManager/Link/${id}`)
            .then((response) => {

            return response;
        });
    },
    // SHARE FILE DATA
    // eslint-disable-next-line no-unused-vars
    async getFileByLinkId({ commit }, data) {
        return await axiosSwagger
            .post("/api/FileManager/Link", data)
            .then((response) => {

            return response;
        });
    },
}